import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import type { ImageLocation } from '@change-corgi/middle-end-gql-schema';

import {
	SharedPhotoUploadInfo,
	type SharedPhotoUploadInfoQuery,
	type SharedPhotoUploadInfoQueryVariables,
} from './index.graphql';

export async function getPhotoUploadCredentials(
	name: string,
	{ gql: { fetch }, errorReporter }: UtilityContext,
	imageLocation: ImageLocation,
): Promise<SharedPhotoUploadInfoQuery['photoUploadCredentials']> {
	try {
		const { data } = await fetch<SharedPhotoUploadInfoQuery, SharedPhotoUploadInfoQueryVariables>({
			query: SharedPhotoUploadInfo,
			variables: { name, folder: imageLocation },
			rejectOnError: true,
		});

		return data?.photoUploadCredentials || null;
	} catch (error) {
		void errorReporter.report({
			error: error instanceof Error ? error : new Error('Failed to get photo upload credentials'),
			context: {
				reason: 'Failed to get photo upload credentials',
			},
		});
		return null;
	}
}
